require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./was-wird-sich-veraendern.json") })
        }
      }, "path---was-wird-sich-veraendern");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---was-wird-sich-veraendern!./.cache/json/was-wird-sich-veraendern.json
// module id = 434
// module chunks = 231608221292675